import React from "react";
import { useTranslation } from "react-i18next";
import {
    ClipboardIcon,
    ArrowPathIcon,
    PlusIcon,
    TrashIcon,
    ClockIcon,
} from "@heroicons/react/24/outline";
import { toast } from "react-toastify";

/**
 * Format remaining time until a Date as a human-readable string.
 * e.g. "23 h 45 m" or "Expired"
 */
// function formatTimeRemaining(expiresAt) {
//     if (!expiresAt) return null;
//     const diff = new Date(expiresAt).getTime() - Date.now();
//     if (diff <= 0) return "Expired";
//     const totalMinutes = Math.floor(diff / 60000);
//     const hours = Math.floor(totalMinutes / 60);
//     const minutes = totalMinutes % 60;
//     if (hours > 0) return `${hours}h ${minutes}m`;
//     return `${minutes}m`;
// }

const SidebarMailboxActions = ({ mailbox, onRefresh, onNew, onDelete }) => {
    const { t } = useTranslation();

    if (!mailbox) return null;

    const handleCopy = async () => {
        try {
            await navigator.clipboard.writeText(mailbox.address);
            toast.success("Copied to clipboard!");
        } catch (err) {
            console.error("Copy failed", err);
            toast.error("Copy failed");
        }
    };

    // const timeRemaining = formatTimeRemaining(mailbox.expiresAt);

    return (
        <div className="mt-6 space-y-3">
            {/* Active mailbox address */}
            <div className="space-y-1">
                <label className="text-xs text-white/80">Mailbox</label>
                <input
                    readOnly
                    value={mailbox.address}
                    className="w-full rounded-md px-3 py-2 text-xs bg-white text-gray-900 focus:outline-none cursor-pointer"
                    onClick={handleCopy}
                    title="Click to copy"
                />
            </div>

            {/* Expiry indicator */}
            {/* {timeRemaining && (
                <div
                    className={`flex items-center gap-1 text-xs px-2 py-1 rounded-md ${
                        timeRemaining === "Expired"
                            ? "bg-red-500/30 text-red-200"
                            : "bg-white/10 text-white/80"
                    }`}
                >
                    <ClockIcon className="w-3 h-3 flex-shrink-0" />
                    <span>
                        {timeRemaining === "Expired"
                            ? "Mailbox expired"
                            : `Expires in ${timeRemaining}`}
                    </span>
                </div>
            )} */}

            {/* Action buttons */}
            <div className="grid grid-cols-2 sm:grid-cols-4 gap-2">
                <button
                    type="button"
                    onClick={handleCopy}
                    className="aspect-square flex flex-col items-center justify-center rounded-md bg-white/10 hover:bg-white/20 text-white text-[10px] transition-colors"
                >
                    <ClipboardIcon className="w-4 h-4 mb-1" />
                    {t("copy")}
                </button>
                <button
                    type="button"
                    onClick={onRefresh}
                    className="aspect-square flex flex-col items-center justify-center rounded-md bg-white/10 hover:bg-white/20 text-white text-[10px] transition-colors"
                >
                    <ArrowPathIcon className="w-4 h-4 mb-1" />
                    {t("refresh")}
                </button>
                <button
                    type="button"
                    onClick={onNew}
                    className="aspect-square flex flex-col items-center justify-center rounded-md bg-white/10 hover:bg-white/20 text-white text-[10px] transition-colors"
                >
                    <PlusIcon className="w-4 h-4 mb-1" />
                    {t("newMailbox")}
                </button>
                <button
                    type="button"
                    onClick={onDelete}
                    className="aspect-square flex flex-col items-center justify-center rounded-md bg-red-500/80 hover:bg-red-600 text-white text-[10px] transition-colors"
                >
                    <TrashIcon className="w-4 h-4 mb-1" />
                    {t("delete")}
                </button>
            </div>
        </div>
    );
};

export default SidebarMailboxActions;
